var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005281"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11264",
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E3E5E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000005282"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14181_30472",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 11264_2",
    width: 40,
    height: 40,
    rx: 8,
    fill: "#E3E5E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14181_30472)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 11265",
    d: "M5 38C5 31.3726 10.3726 26 17 26H22C28.6274 26 34 31.3726 34 38V40H5V38Z",
    fill: "#737E93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 3791",
    cx: 20,
    cy: 15,
    r: 8,
    fill: "#737E93"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9088268df65e331429e8491c70f1231a.svg";
export { ForwardRef as ReactComponent };